var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"DownloadCenter"}},[_c('view1'),_c('view2')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }